// ***** DEVEXTREME *****
import {
    DevExtremeModule,
    DxDataGridModule,
    DxFileUploaderModule,
    DxCheckBoxModule,
    DxSelectBoxModule,
    DxButtonModule,
    DxDropDownBoxModule,
    DxAutocompleteModule,
    DxTemplateModule
} from 'devextreme-angular';
// **********************    Graficas
// import * as echarts from 'echarts';
// import { NgxEchartsModule } from 'ngx-echarts';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridComponentComponent } from 'app/utilerias/grid-component/grid-component.component';
import { ConfirmDialogComponent } from 'app/utilerias/confirm-dialog/confirm-dialog.component';
import { RelacionadosDialogComponent } from 'app/utilerias/relacionados-dialog/relacionados-dialog.component';
// import { NgApexchartsModule } from 'ng-apexcharts';
import { MaterialModule } from 'app/material.module';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { ConfirmDialogOpcionComponent } from 'app/utilerias/confirm-dialog-opcion/confirm-dialog-opcion.component';
import { ConfirmDialogOkComponent } from 'app/utilerias/confirm-dialog-ok/confirm-dialog-ok.component';
import { SpinnerUtileriaComponent } from 'app/utilerias/spinner-utileria/spinner-utileria.component';
import { CustomAlertComponent } from 'app/utilerias/custom-alert/custom-alert.component';
import { CurrencyMaskModule } from "ng2-currency-mask";


@NgModule({
    declarations: [
        //UTILERIAS
        GridComponentComponent,
        CustomAlertComponent,
        //GridComponentComponent,
        ConfirmDialogOpcionComponent,
        ConfirmDialogComponent,
        RelacionadosDialogComponent,
        ConfirmDialogOkComponent,
        SpinnerUtileriaComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,

        // DEVEXTREME
        DevExtremeModule,
        DxDataGridModule,
        DxFileUploaderModule,
        DxCheckBoxModule,
        DxSelectBoxModule,
        DxButtonModule,
        DxDropDownBoxModule,
        DxAutocompleteModule,
        DxTemplateModule,

        // Angular Materal
        MaterialModule,
        MatSnackBarModule,
        CurrencyMaskModule,

        //*** GRaficas */
        // NgxEchartsModule.forRoot({
        //     echarts
        //   }),
    ],
    exports: [
        // MatSnackBarModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        // DEVEXTREME
        DevExtremeModule,
        DxDataGridModule,
        DxFileUploaderModule,
        DxCheckBoxModule,
        DxSelectBoxModule,
        DxButtonModule,
        DxDropDownBoxModule,
        DxAutocompleteModule,
        DxTemplateModule,
        // Angular Materal
        MaterialModule,

        // **********    GRAFICAS
        // NgApexchartsModule,
        // TranslocoModule,
         //UTILERIAS
         GridComponentComponent,
         SpinnerUtileriaComponent,
         CustomAlertComponent,
        CurrencyMaskModule,

        //  AlertDialogComponent,
        //  FileUploadComponent,
        //  ExcepcionesComponent,
        //  ViewerComponent,
        //  DeleteAlertComponent,
        //  BreadcrumbsComponent
    ],
})
export class SharedModule
{
}
